// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__2braq","white":"Select_white__1ciyl","black":"Select_black__1gCjh","content":"Select_content__2-gJ-"};